/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Temporisationmidseason2Inputs */



/**
* | output |
* | --- |
* | "Mid-season temporization" |
*
* @param {Ahu_History_Key_Temporisationmidseason2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_temporisationmidseason2 = /** @type {((inputs?: Ahu_History_Key_Temporisationmidseason2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Temporisationmidseason2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Mid-season temporization")
	return /** @type {LocalizedString} */ ("Temporisation mi-saison")
});
export { ahu_history_key_temporisationmidseason2 as "ahu_history_key_temporisationMidSeason" }